import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { config } from '../../../../config/config';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../base.component';
import { SuccessWrapComponent } from '../success.wrap/success.wrap.component';
import {
  ResizeImageModalActions,
  ResizeImageModalData,
} from '../../../components/hub/resize.image.modal/resize.image.modal.provider';
import { ButtonTriggerEvent } from '..';
import { ResizeImageModalComponent } from '../../../components/hub/resize.image.modal/resize.image.modal.component';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'ig-image-resize',
  templateUrl: './image.resize.component.html',
  styleUrls: ['./image.resize.component.scss'],
})
export class ImageResizeComponent extends BaseComponent implements OnInit {
  public resizeImageTemp: string;
  @Input() public imageToResize: File | string;
  @Output() public onImageResized = new EventEmitter<string>();
  @ViewChild('upload') public uploadImageSuccess: SuccessWrapComponent;

  constructor(private modalService: ModalService, private imageService: ImageService) {
    super();
  }

  public ngOnInit() {}

  public async resizeImage($event) {
    if ($event) {
      $event.stopPropagation();
      $event.preventDefault();
    }

    let actions = <ResizeImageModalActions>{
      confirm: (event: ButtonTriggerEvent, image: string) => {
        // !!image && (this.resizeImageTemp = image);
        this.onImageResized.emit(image);
      },
    };

    if (typeof this.imageToResize !== 'string') {
      this.resizeImageTemp = await this.imageService.compressImageFileToBase64(
        this.imageToResize,
        config.compressImgWidth
      );
    } else {
      this.resizeImageTemp = this.imageToResize;
    }

    let data = <ResizeImageModalData>{
      data: this.resizeImageTemp,
    };

    this.modalService.show({
      component: ResizeImageModalComponent,
      providers: [
        { provide: ResizeImageModalActions, useValue: actions },
        { provide: ResizeImageModalData, useValue: data },
      ],
      panelClass: 'width-modal-2',
    });
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/image.rezise/image.resize.component.ts